export default __webpack_public_path__ + "static/media/bottle.7252e9b2.jpg";